<template>
  <div class="container-fluid">
    <div class="row g-3">
      <PanelsItem
        v-for="panel in panels"
        class="col-12 col-sm-6 col-lg-4 col-xl"
        :key="panel.index"
        :panel="panel"
        :sm="sm"
        :containImage="containImage"
      />
    </div>
  </div>
</template>

<script>
import PanelsItem from "./PanelsItem";

export default {
  name: "PanelsList",
  components: {
    PanelsItem
  },
  props: {
    panels: {
      type: Array,
      required: true
    },
    sm: {
      type: Boolean,
      required: false
    },
    containImage: {
      type: Boolean,
      required: false
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.panels-wrapper {
  overflow: scroll;
  margin-bottom: 1rem;
}

.panels {
  width: auto;
  display: flex;
  flex-direction: row;
}

.panel-wrapper {
  transition: opacity 0.2s ease;
}

/* .panels:hover {
  ::v-deep .panels-item {
    opacity: 0.65;

    &:hover {
      opacity: 1;
    }
  }
} */
</style>
